<template>
  <div style="height: 100%">
    <mu-content-block
      class="food-search-dialog"
      style="padding-bottom: 0; margin-bottom: 8px;"
      v-bind:style="{height: (isSearching === true) ? '100%': 'auto'}">
      <mu-paper class="search-area">
        <mu-flexbox style="height: 100%" align="center">
          <mu-flexbox-item grow="45" shrink="45">
            <mu-text-field
              icon="search"
              hintText="Search a food name"
              :underlineShow="false"
              hintTextClass="hidden"
              v-model.lazy="searchValue"
              fullWidth
            ></mu-text-field>
          </mu-flexbox-item>
          <mu-flexbox-item shrink="5" grow="5" @click.native="goBack()" align="right">
            <mu-icon-button icon="close"></mu-icon-button>
          </mu-flexbox-item>
        </mu-flexbox>
      </mu-paper>


      <mu-flexbox v-if="isSearching" align="center" justify="center" style="height: 100%">
        <mu-flexbox-item align="center">
          <mu-circular-progress :size="24"></mu-circular-progress>
          <br/>
          <span v-text="$t('message.loadingText')"></span>
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-content-block>

    <mu-flexbox v-if="isListening" align="center" justify="center" style="height: 100%">
      <div class="load-wrapp">
        <div class="load-3 bottom">
          <div class="line loaderRed"></div>
          <div class="line loaderGreen"></div>
          <div class="line loaderBlue"></div>
        </div>
        <div class="bottom">
          Go ahead and say something...
        </div>
        <mu-raised-button
          label="Stop"
          @click.native="stopVoiceRecognition()"
        ></mu-raised-button>
      </div>
    </mu-flexbox>
    <mu-list v-if="!isListening" class="oddEven">
      <mu-list-item
        disableRipple
        v-for="suggestion, index in suggestions"
        :key="'suggestion-' + index "
        @click.native="handleSelection(suggestion)"
      >
        <mu-icon slot="left" value="search"></mu-icon>
        <div slot="title" v-html="$sanitize(highlight(suggestion))" v-once></div>
      </mu-list-item>
    </mu-list>
  </div>
</template>
<script>
  import FdAutocompleteDialog from "../../../components/FoodDiary/AutocompleteDialog/AutocompleteDialog";
  import FoodApi from '../../../api/Food'
  
  import {Observable} from 'rxjs/Rx'

  export default {
    components: {
      FdAutocompleteDialog
    },
    props: {
      title: {
        type: String,
        default: "Breakfast"
      },
      mealTypeId: {
        type: Number,
        default: 1
      },
      date: {
        type: Object
      }
    },
    data() {
      return {
        recognition: null,
        isListening: false,
        isSearching: false,
        searchValue: "",
        suggestions: []
      }
    },
    watch: {
      'searchValue': function () {
        if (this.searchValue === "") {
          this.suggestions = [];
        }
      }
    },
    mounted() {
      let self = this;
      $('.mu-text-field-input').focus();
      self.searchValue = self.searchTerm;
      if (self.$route.query.q !== "") {
        self.searchValue = self.$route.query.q;
      }
      if (self.searchTerm !== "") {
        self.autoComplete();
      }
      self.initScrollFix();
      $(window).resize(function () {
        self.initScrollFix();
      });
      const autoCompleteElement = $('.mu-paper.search-area .mu-text-field-input');
      const observableConditionElement = Observable.fromEvent(autoCompleteElement, 'keydown').map(x => x)
      const delayedSearch = observableConditionElement.debounceTime(300).distinctUntilChanged();
      delayedSearch.subscribe(function (e) {
        if (e.key === "Enter") {
          self.handleSelection(self.searchValue);
        }
        if (self.searchValue !== "") {
          self.autoComplete()
        }
      });
    },
    methods: {
      initScrollFix() {
        let searchArea = $('.mu-content-block.food-search-dialog').outerHeight(true) + 8;
        let header = $('.mu-appbar').outerHeight(true);
        let mainContent = $(window).outerHeight(true);
        mainContent = mainContent - (header + searchArea);
        $('.oddEven').attr('style', 'height:' + mainContent + 'px;padding-top: 0px; padding-bottom: 0px;');
      },
      goBack() {
        let self = this;
        self.$router.push({
          name: 'FoodDiaryLanding',
          query: {
            date: self.$route.query.date,
            mealTypeId: self.$route.query.mealTypeId
          },
          params: {
            title: self.title,
            mealTypeId: self.mealTypeId
          }
        })
      },
      handleSelection(food) {
        let self = this;
        self.$router.push({
          name: 'FoodDiarySearchResults',
          query: {
            q: food,
            date: self.$route.query.date,
            mealTypeId: self.$route.query.mealTypeId
          },
          params: {
            title: self.title,
            mealTypeId: self.mealTypeId
          }
        })
      },
      highlight(word) {
        let self = this;
        return word.replace(self.searchValue.toLowerCase(), '<span class=\'highlight\'>' + self.searchValue.toLowerCase() + '</span>')
      },
      autoComplete() {
        let self = this;
        self.isSearching = true;
        self.suggestions = [];
        FoodApi.autoComplete(self.searchValue)
          .then(function (response) {
            self.suggestions = response.data;
            self.isSearching = false;
          })
      },
      closeDialog() {
        this.$emit('closeDialog')
      }
    }
  }
</script>
<style scoped></style>
<style>
  .oddEven .mu-item-left {
    left: 24px;
  }

  div#food-diary-search {
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-top: 8px !important;
    padding-bottom: 0 !important;
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// Search.vue?448f23a4